var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScroll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 123 123",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_1-2",
    "data-name": "\\u5716\\u5C64 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 61.5,
    cy: 61.5,
    r: 59
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.5 50.5 61.5 69.83 89.06 50.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "35.84 64.84 61.84 84.17 89.39 64.84"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.0c147208.svg";
export { ForwardRef as ReactComponent };